import { type Reducer } from 'redux';

const initialState = {};

const maintenanceReducer: Reducer<Record<string, any>> = (
  state = initialState,
  { payload },
) => {
  if (payload?.code === 503) {
    return { underMaintenance: true, ...payload };
  }

  return state;
};

export default maintenanceReducer;
